/**
 * Frontend Release History (Internal user)
 *
 * This file tracks all internal user frontend releases with their versions,
 * builds, and deployment information.
 * Release type: Feature, Bugfix, Hotfix, Security, Update, Maintenance
 * Commit type: feat, fix, docs, style, refactor, perf, test, chore, ci, build, i18n
 */
const RELEASES = [
  {
    id: 'int-v4.9.0+01',
    version: 'int-v4.9.0',
    type: 'Feature',
    title: 'Add degree and consideration title by Proponent fields to UI',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-05-21',
      date: '2026-07-02',
      commits: [
        {
          type: 'docs',
          message: 'Update release history for int-v4.9.0',
          date: '2026-07-02',
          sha: 'xxxxxxxx',
          author: 'symeon',
          issues: [112]
        },
        {
          type: 'feat',
          message: 'Add consideration title by Proponent field to UI',
          date: '2026-06-08',
          sha: 'fe4357c3f141b11b9d651cfd6ad63313a41e7f7c',
          author: 'symeon',
          issues: [112]
        },
        {
          type: 'feat',
          message: 'Add max length and wrapping for degree title field',
          date: '2026-06-03',
          sha: '574a0ca51696f44aa5de06a842a4751688b2b484',
          author: 'symeon',
          issues: [112]
        },
        {
          type: 'fix',
          message: 'Handle academic field for post-exam applications on Proponent UI',
          date: '2026-05-26',
          sha: 'feb1e360611a9e05b25baf456ad7459ab0819c82',
          author: 'symeon',
          issues: []
        },
        {
          type: 'feat',
          message: 'Add degree title by Proponent field to UI',
          date: '2026-05-26',
          sha: '85851abac5a8888017ce339af92e4ee45aecf515',
          author: 'symeon',
          issues: [112]
        }
      ]
    }
  },
  {
    id: 'int-v4.8.2+01',
    version: 'int-v4.8.2',
    type: 'Bugfix',
    title: 'Fix date downloaded field',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-06-23',
      date: '2026-07-01',
      commits: [
        {
          type: 'refactor',
          message: 'Extract downloadedAt computed to avoid duplication',
          date: '2026-07-01',
          sha: '3e2b22c0cb1a6e579b6ce9dd49e2cc8f278402df',
          author: 'symeon',
          issues: [115]
        },
        {
          type: 'fix',
          message: 'Fix date downloaded field value on Search Application form',
          date: '2026-07-01',
          sha: 'aa1ed81117c4ad5f3a8339580bd9f72840188cbf',
          author: 'symeon',
          issues: [115]
        }
      ]
    }
  },
  {
    id: 'int-v4.8.1+01',
    version: 'int-v4.8.1',
    type: 'Bugfix',
    title: 'Fix PDF upload failure handling and large file preview in browser',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-05-06',
      date: '2026-05-25',
      commits: [
        {
          type: 'docs',
          message: 'Update release history for int-v4.8.1',
          date: '2026-05-25',
          sha: '730768b717c21d7047903ae83db956aeb72fd62a',
          author: 'symeon',
          issues: [108]
        },
        {
          type: 'fix',
          message: 'Handle oversized pdf file upload error on Reappraisal Board Member UI',
          date: '2026-05-19',
          sha: '10de9a35419793534422f284147047bce7771c86',
          author: 'symeon',
          issues: [108]
        },
        {
          type: 'chore',
          message: 'Remove leftover bebug message',
          date: '2026-05-19',
          sha: '48e76a9d2b1d1eecc773761358b109833a05214e',
          author: 'symeon',
          issues: []
        },
        {
          type: 'fix',
          message: 'Fix pdf preview on Reappraisal Board Member UI',
          date: '2026-05-19',
          sha: 'e12ad019a1317c82db84fc042c53c55f0ad969e6',
          author: 'symeon',
          issues: []
        },
        {
          type: 'fix',
          message: 'Handle oversized pdf file upload error on Special Proponent UI',
          date: '2026-05-19',
          sha: 'b28820769a9fdf065f13ef890f4e9b43c948e326',
          author: 'symeon',
          issues: [108]
        },
        {
          type: 'fix',
          message: 'Use blob URL in PDF viewer to prevent browser from blocking data URIs',
          date: '2026-05-18',
          sha: 'f572b9b0ba259627ffdfe36bd88ae104be628f0a',
          author: 'symeon',
          issues: []
        },
        {
          type: 'fix',
          message: 'Stop loading spinner on upload error and improve error message for oversized files',
          date: '2026-05-18',
          sha: 'd3a9e0f3726c3d2ced0b3f198fbd3a3cc6fd6f68',
          author: 'symeon',
          issues: [108]
        }
      ]
    }
  },
  {
    id: 'int-v4.8.0+01',
    version: 'int-v4.8.0',
    type: 'Feature',
    title: 'Optional role assignment',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-04-24',
      date: '2026-05-14',
      commits: [
        {
          type: 'docs',
          message: 'Update release history for int-v4.8.0',
          date: '2026-04-14',
          sha: '988f5b488369f5b58142a8204ccb535fd8a1e011',
          author: 'symeon',
          issues: [72]
        },
        {
          type: 'chore',
          message: 'Merge branch hotfix/mfa-login-patches into feature/optional-role-assignment',
          date: '2026-05-14',
          sha: 'a6d711785b06dd7319d5b9ede2a3970f4a12fe1f',
          author: 'symeon',
          issues: [86, 111]
        },
        {
          type: 'fix',
          message: 'Correct dates in release history',
          date: '2026-04-13',
          sha: 'b76050dd1c2ed05d827b9f0c6cdeca8587a1d650',
          author: 'symeon',
          issues: [72]
        },
        {
          type: 'docs',
          message: 'Update release history',
          date: '2026-04-12',
          sha: '78df8c4d6ef3e794b09c6e576e48f58c6c4ca29a',
          author: 'symeon',
          issues: [72]
        },
        {
          type: 'feat',
          message: 'Show role/user change summary dialog before saving',
          date: '2026-04-12',
          sha: 'dd5139e3dab4cb5d100b2c00f9329d3519015176',
          author: 'symeon',
          issues: [72]
        },
        {
          type: 'feat',
          message: 'Allow user save without role assignment',
          date: '2026-04-12',
          sha: 'b89ed0bb8ac9d6d54ff47101c9c26d9114ed1e57',
          author: 'symeon',
          issues: [72]
        },
        {
          type: 'refactor',
          message: 'Convert template from Pug to HTML, fix popover directives',
          date: '2026-04-12',
          sha: 'd13207a2ba4996c1103d2c0121eb4681064b1c6f',
          author: 'symeon',
          issues: [72]
        }
      ]
    }
  },
  {
    id: 'int-v4.7.2+01',
    version: 'int-v4.7.2',
    type: 'Hotfix',
    title: 'Re-enable session refresh on timer button click',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-05-13',
      date: '2026-05-14',
      commits: [
        {
          type: 'fix',
          message: 'Re-enable session refresh on timer button click',
          date: '2026-05-14',
          sha: '6431bfdebf959da23bd2e37eaf59c6d32dc5cd22',
          author: 'symeon',
          issues: [111]
        }
      ]
    }
  },
  {
    id: 'int-v4.7.1+01',
    version: 'int-v4.7.1',
    type: 'Hotfix',
    title: 'Handle 429 throttling error in loginMFA with custom notification',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-05-13',
      date: '2026-05-14',
      commits: [
        {
          type: 'fix',
          message: 'Simplify 429 throttling error message to essential user instruction',
          date: '2026-05-14',
          sha: '174776ba5242dee82a6b0536a288376fa68e5425',
          author: 'symeon',
          issues: [86]
        },
        {
          type: 'fix',
          message: 'Handle 429 throttling error in loginMFA with custom notification',
          date: '2026-05-13',
          sha: '52d918bb00cfd432276dce2973d1c92c14781de9',
          author: 'symeon',
          issues: [86]
        }
      ]
    }
  },
  {
    id: 'int-v4.7.0+01',
    version: 'int-v4.7.0',
    type: 'Feature',
    title: 'Extend session timeout to 3h with HH:MM:SS countdown display',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-05-08',
      date: '2026-05-11',
      commits: [
        {
          type: 'chore',
          message: 'Update releases.js after resolving merge conflicts',
          date: '2026-05-11',
          sha: 'cd46fcea2d1ff185caa44bb82273978bffe32c42',
          author: 'symeon',
          issues: []
        },
        {
          type: 'chore',
          message: 'Merge branch feature/extend-session-timeout into feature/mfa-login-temp',
          date: '2026-05-11',
          sha: '6b887f5d79a55bdd5bd991068c716ea20f9d1d81',
          author: 'symeon',
          issues: []
        },
        {
          type: 'feat',
          message: 'Extend session timeout to 3h with HH:MM:SS countdown display',
          date: '2026-05-08',
          sha: '4ab3b9a3ec931c3f1459756c66c8642da32f580e',
          author: 'symeon',
          issues: [111]
        }
      ]
    }
  },
  {
    id: 'int-v4.6.0-rc.1+01',
    version: 'int-v4.6.0-rc.1',
    type: 'Feature',
    title: 'Add OTP MFA flow and refine login UX',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-04-30',
      date: '2026-05-07',
      commits: [
        {
          type: 'feat',
          message: 'Improve OTP form UX with auto-focus and remove status icons',
          date: '2026-05-07',
          sha: 'b8c53513d540fa89485e6e49b02992462f8b0946',
          author: 'symeon',
          issues: [86]
        },
        {
          type: 'feat',
          message: 'Add password visibility toggle to login form',
          date: '2026-05-07',
          sha: 'b264741dd2e7221c7ee8b9c5d71fa02d37a2b980',
          author: 'symeon',
          issues: [86]
        },
        {
          type: 'build',
          message: 'Update backend port configuration for local development',
          date: '2026-05-07',
          sha: '7bdb3546c2b53ba4c0d38e490b6e8028a5964b61',
          author: 'symeon',
          issues: []
        },
        {
          type: 'fix',
          message: 'Use auto-complete prop syntax for Element UI inputs',
          date: '2026-05-05',
          sha: '1837ab897622828e002eeb002cdddd1adfbb61b6',
          author: 'symeon',
          issues: [86]
        },
        {
          type: 'feat',
          message: 'Display masked email address on OTP screen',
          date: '2026-05-05',
          sha: '9a9272e7ed22f5f718e6d5d7149f2b0958ff7ab4',
          author: 'symeon',
          issues: [86]
        },
        {
          type: 'feat',
          message: 'Handle direct login for roles without OTP and compact Login.vue template',
          date: '2026-05-05',
          sha: 'd2bb631cf2560b7710683c5e0a37004eae81448d',
          author: 'symeon',
          issues: [86]
        },
        {
          type: 'feat',
          message: 'Add OTP MFA flow and refine login UX',
          date: '2026-05-05',
          sha: '4bf1e0dda736d9e87679f13f716c66548d24bd47',
          author: 'symeon',
          issues: [86]
        }
      ]
    }
  },
  {
    id: 'int-v4.5.0+01',
    version: 'int-v4.5.0',
    type: 'Feature',
    title: 'Add Relevant Application tab to Application History',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-03-31',
      date: '2026-04-02',
      commits: [
        {
          type: 'fix',
          message: 'Activate Personal Data tab by default on Application Details dialog open',
          date: '2026-04-02',
          sha: '421f5f2b4231a812dea5884eec745ded6e960ae1',
          author: 'symeon',
          issues: [106]
        },
        {
          type: 'feat',
          message: 'Add missing Relevant Application tab to the user applications list in President UI',
          date: '2026-03-31',
          sha: '17532d977a74683afe34ccb18817fc15d63e4a2a',
          author: 'symeon',
          issues: [106]
        }
      ]
    }
  },
  {
    id: 'int-v4.4.0+01',
    version: 'int-v4.4.0',
    type: 'Feature',
    title: 'Add hierarchical title programme selection support',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-03-09',
      date: '2026-03-10',
      commits: [
        {
          type: 'chore',
          message: 'Remove Department label from Titles tab',
          date: '2026-03-10',
          sha: '2dc122c8398d9258eba9b8c3c61a3d64f975b680',
          author: 'symeon',
          issues: [88]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.3+01',
    version: 'int-v4.3.3',
    type: 'Bugfix',
    title: 'Fix typo in Prechecker (post-exam) application status label',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-02-20',
      date: '2026-02-20',
      commits: [
        {
          type: 'fix',
          message: 'Fix typo in Prechecker (post-exam) application status label',
          date: '2026-02-20',
          sha: '18393b5d3befcf63f1925793d57134304cafeba2',
          author: 'symeon',
          issues: []
        }
      ]
    }
  },
  {
    id: 'int-v4.3.2+01',
    version: 'int-v4.3.2',
    type: 'Feature',
    title: 'Add reroute to Print Decision queue button on Admin UI',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-01-28',
      date: '2026-02-02',
      commits: [
        {
          type: 'feat',
          message: 'Add reroute to Print Decision queue button on Admin UI.',
          date: '2026-02-02',
          sha: '63dad3aec581fb867a3b0439710f817664a97df4',
          author: 'symeon',
          issues: [28]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.1+02',
    version: 'int-v4.3.1',
    type: 'Feature',
    title: 'Allow President to renotify letter of overdue rejection and letter of persistance in previous decision',
    build: {
      number: '02',
      author: 'symeon',
      startDate: '2025-12-17',
      date: '2025-12-18',
      commits: [
        {
          type: 'chore',
          message: 'Refine release history structure and footer tooltip',
          date: '2025-12-18',
          sha: '',
          author: 'symeon',
          issues: []
        },
        {
          type: 'style',
          message: 'Add Relevant Application Attachments caption',
          date: '2025-12-18',
          sha: '16d0fb2eba6337329f78dd9ae0f7946571085bda',
          author: 'symeon',
          issues: [97]
        },
        {
          type: 'fix',
          message: 'Update renotification labels',
          date: '2025-12-17',
          sha: '2fb65432cb89b0742377a98a91ae18dde67f025d',
          author: 'symeon',
          issues: [101]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.1+01',
    version: 'int-v4.3.1',
    type: 'Feature',
    title: 'Allow President to renotify letter of overdue rejection and letter of persistance in previous decision',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-12-15',
      date: '2025-12-16',
      commits: [
        {
          type: 'feat',
          message: 'Allow President to renotify letter of overdue rejection and letter of persistance in previous decision',
          date: '2025-12-16',
          sha: 'ed0893deb1bb169347cebd77b1d2511a1ff20b18',
          author: 'symeon',
          issues: [101]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0+05',
    version: 'int-v4.3.0',
    type: 'Feature',
    title: 'Add post-exam application support',
    build: {
      number: '05',
      author: 'symeon',
      startDate: '2025-12-08',
      date: '2025-12-10',
      commits: [
        {
          type: 'feat',
          message: 'Add build metadata to releases and display in footer tooltips',
          date: '2025-12-10',
          sha: '34e3e404fb3cac2fa0260682ec49105e69fed817',
          author: 'symeon',
          issues: [90, 97]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0+04',
    version: 'int-v4.3.0',
    type: 'Feature',
    title: 'Add post-exam application support',
    build: {
      number: '04',
      author: 'symeon',
      startDate: '2025-12-04',
      date: '2025-12-08',
      commits: [
        {
          type: 'style',
          message: 'Update post-exam application creation button caption. Adjust grade form item height.',
          date: '2025-12-08',
          sha: '449405f51bb1961a21140aea57d6d30ba951139d',
          author: 'symeon',
          issues: [90, 97]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0+03',
    version: 'int-v4.3.0',
    type: 'Feature',
    title: 'Add post-exam application support',
    build: {
      number: '03',
      author: 'symeon',
      startDate: '2025-12-03',
      date: '2025-12-03',
      commits: [
        {
          type: 'build',
          message: 'Update patch version number',
          date: '2025-12-03',
          sha: 'f1f0d0d920cbaa4f3aa100ddc38863bcb1f6c44f',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0+02',
    version: 'int-v4.3.0',
    type: 'Feature',
    title: 'Add post-exam application support',
    build: {
      number: '02',
      author: 'symeon',
      startDate: '2025-12-02',
      date: '2025-12-03',
      commits: [
        {
          type: 'style',
          message: 'Update post-exam application support texts',
          date: '2025-12-03',
          sha: 'ebaebd3d72c691fae9fe38f1d47311b789b3597b',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0+01',
    version: 'int-v4.3.0',
    type: 'Feature',
    title: 'Add post-exam application support',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-12-01',
      date: '2025-12-01',
      commits: [
        {
          type: 'feat',
          message: 'Add post-exam application support',
          date: '2025-12-01',
          sha: 'ce66c1849d4aecefa31e021779e1ffd7a0e79a63',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0-rc.1+03',
    version: 'int-v4.3.0-rc.1',
    type: 'Feature',
    title: 'Add post-exam application support (RC)',
    build: {
      number: '03',
      author: 'symeon',
      startDate: '2025-11-28',
      date: '2025-12-01',
      commits: [
        {
          type: 'fix/style',
          message: 'Fix enabled final save button without grade input on Proponent UI. Update UI text.',
          date: '2025-12-01',
          sha: '6085333f03001e442296d76dee28f33293d44dfa',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0-rc.1+02',
    version: 'int-v4.3.0-rc.1',
    type: 'Feature',
    title: 'Add post-exam application support (RC)',
    build: {
      number: '02',
      author: 'symeon',
      startDate: '2025-11-28',
      date: '2025-11-28',
      commits: [
        {
          type: 'fix',
          message: 'Show release button on President to Print decision UI',
          date: '2025-11-28',
          sha: 'ef307e18421355cf77400a1b57c99a42d7d51d2e',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0-rc.1+01',
    version: 'int-v4.3.0-rc.1',
    type: 'Feature',
    title: 'Add post-exam application support (RC)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-11-27',
      date: '2025-11-27',
      commits: [
        {
          type: 'feat',
          message: 'Add President finalization post-exam application support',
          date: '2025-11-27',
          sha: '300f009050c2d4e070273929a3b2c7dd7f11cb0c',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0-dev.6+01',
    version: 'int-v4.3.0-dev.6',
    type: 'Feature',
    title: 'Add Print Decision post-exam application support (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-11-25',
      date: '2025-11-27',
      commits: [
        {
          type: 'feat',
          message: 'Add Print Decision post-exam application support',
          date: '2025-11-27',
          sha: 'b635735bb5e3f528a2acf8cb8701af05f4e0933c',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0-dev.5+01',
    version: 'int-v4.3.0-dev.5',
    type: 'Feature',
    title: 'Add President (to Print Decision) post-exam application support (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-11-25',
      date: '2025-11-25',
      commits: [
        {
          type: 'feat',
          message: 'Add President (to Print Decision) post-exam application support',
          date: '2025-11-25',
          sha: 'a09ffb6bb2e990b738ae7b0a9421dfcfa8e1136a',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0-dev.4+01',
    version: 'int-v4.3.0-dev.4',
    type: 'Feature',
    title: 'Add Process Viewer post-exam application support (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-11-19',
      date: '2025-11-24',
      commits: [
        {
          type: 'feat',
          message: 'Add Process Viewer post-exam application support',
          date: '2025-11-24',
          sha: 'eb8555467b30b9cf1e5590241e6e698ddb08889d',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0-dev.3+01',
    version: 'int-v4.3.0-dev.3',
    type: 'Feature',
    title: 'Add Special proponent post-exam application support (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-11-19',
      date: '2025-11-20',
      commits: [
        {
          type: 'feat',
          message: 'Add Special proponent post-exam application support',
          date: '2025-11-20',
          sha: '3a5546ba7b687931d5a8c28df6a4b8c115d6612c',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0-dev.2+05',
    version: 'int-v4.3.0-dev.2',
    type: 'Feature',
    title: 'Add Prechecker post-exam application support (DEV)',
    build: {
      number: '05',
      author: 'symeon',
      startDate: '2025-11-18',
      date: '2025-11-18',
      commits: [
        {
          type: 'fix',
          message: 'Fix disable post-exam application on Prechecker',
          date: '2025-11-18',
          sha: 'b296e7418af2b77d7475d332a5c3379196f1b14c',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0-dev.2+04',
    version: 'int-v4.3.0-dev.2',
    type: 'Feature',
    title: 'Add Prechecker post-exam application support (DEV)',
    build: {
      number: '04',
      author: 'symeon',
      startDate: '2025-11-13',
      date: '2025-11-17',
      commits: [
        {
          type: 'feat',
          message: 'Add post-exam application history support',
          date: '2025-11-17',
          sha: '064eed43522e50e1e9f3d207a4491e8ce9332ffe',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0-dev.2+03',
    version: 'int-v4.3.0-dev.2',
    type: 'Feature',
    title: 'Add Prechecker post-exam application support (DEV)',
    build: {
      number: '03',
      author: 'symeon',
      startDate: '2025-11-07',
      date: '2025-11-12',
      commits: [
        {
          type: 'feat',
          message: 'Add post-exam application support to Prechecker judgment form',
          date: '2025-11-12',
          sha: '67daf77bc41baff6fa6613c2723984d6f844e1ec',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0-dev.2+02',
    version: 'int-v4.3.0-dev.2',
    type: 'Feature',
    title: 'Add Prechecker post-exam application support (DEV)',
    build: {
      number: '02',
      author: 'symeon',
      startDate: '2025-11-03',
      date: '2025-11-06',
      commits: [
        {
          type: 'feat',
          message: 'Add University Exams menu item on Prechecker role and adapt assign/release dialog',
          date: '2025-11-06',
          sha: '756d613cad0be012f550f539370d8ab2e121b4f0',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0-dev.2+01',
    version: 'int-v4.3.0-dev.2',
    type: 'Feature',
    title: 'Add create post-exam application button and 7100 app type on filters',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-23',
      date: '2025-10-27',
      commits: [
        {
          type: 'feat',
          message: 'Add create post-exam application button and 7100 app type on filters',
          date: '2025-10-27',
          sha: '30ac143bfdc2000f0ea8534aa606a0435706e40a',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.3.0-dev.1+01',
    version: 'int-v4.3.0-dev.1',
    type: 'Feature',
    title: 'Add compensatory measures search field and decision column on Application Search form (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-22',
      date: '2025-10-22',
      commits: [
        {
          type: 'feat',
          message: 'Add compensatory measures search field and decision column on Application Search form',
          date: '2025-10-22',
          sha: '1b78576607e809d68580baf38b12742c06da485d',
          author: 'symeon',
          issues: [90]
        }
      ]
    }
  },
  {
    id: 'int-v4.2.8+01',
    version: 'int-v4.2.8',
    type: 'Feature',
    title: 'Add accessibility widget',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-16',
      date: '2025-10-16',
      commits: [
        {
          type: 'feat',
          message: 'Add accessibility widget',
          date: '2025-10-16',
          sha: '37a2b52c1b8efe1214700cf44380facdfe88c7b4',
          author: 'symeon',
          issues: []
        }
      ]
    }
  },
  {
    id: 'int-v4.2.7+01',
    version: 'int-v4.2.7',
    type: 'Feature/Bugfix',
    title: 'Add comments on Academic Director judgement (reappraisals) and fix double Prechecker comments',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-06',
      date: '2025-10-09',
      commits: [
        {
          type: 'feat/fix',
          message: 'Add comments on Academic Director judgement (reappraisals) and fix double Prechecker comments',
          date: '2025-10-09',
          sha: '4c1f8a36c4272c5bee70c93aa97c3bd900342897',
          author: 'symeon',
          issues: []
        }
      ]
    }
  },
  {
    id: 'int-v4.2.6+01',
    version: 'int-v4.2.6',
    type: 'Feature',
    title: 'Combined release for #66, #65 and #46 (partial) issues',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-09-17',
      date: '2025-09-17',
      commits: [
        {
          type: 'feat',
          message: 'Combined release for #66, #65 and #46 (partial) issues',
          date: '2025-09-17',
          sha: 'f702c84f6abf4e7677e4c566d882b0f79b74b28d',
          author: 'symeon',
          issues: [66, 65, 46]
        }
      ]
    }
  },
  {
    id: 'int-v4.2.6-rc.1+01',
    version: 'int-v4.2.6-rc.1',
    type: 'Update',
    title: 'Display full format birthdate field on Application search form (Issue #46 - partial)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-09-16',
      date: '2025-09-16',
      commits: [
        {
          type: 'chore',
          message: 'Display full format birthdate field on Application search form',
          date: '2025-09-16',
          sha: 'b54ad8fc47573d08e0c6d2766dd37a1253dcf744',
          author: 'symeon',
          issues: [46]
        }
      ]
    }
  },
  {
    id: 'int-v4.2.5-rc.1+01',
    version: 'int-v4.2.5-rc.1',
    type: 'Feature',
    title: 'Allow reappraisal release from President to Prechecker (Issue #65)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-09-12',
      date: '2025-09-12',
      commits: [
        {
          type: 'feat',
          message: 'Allow reappraisal release from President to Prechecker',
          date: '2025-09-12',
          sha: '53b305c6ec08a423eef22c50c3292bb396bec157',
          author: 'symeon',
          issues: [65]
        }
      ]
    }
  },
  {
    id: 'int-v4.2.4-rc.1+01',
    version: 'int-v4.2.4-rc.1',
    type: 'Feature',
    title: 'Application return to President from Reappraisal board (Issue #66)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-09-05',
      date: '2025-09-05',
      commits: [
        {
          type: 'feat',
          message: 'Application return to President from Reappraisal board',
          date: '2025-09-05',
          sha: '',
          author: 'symeon',
          issues: [66]
        }
      ]
    }
  },
  {
    id: 'int-v4.2.3+01',
    version: 'int-v4.2.3',
    type: 'Bugfix',
    title: 'Fix Council Members missing on President\'s Special Reappraisal Board member selection list (Issue #70)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-09-05',
      date: '2025-09-05',
      commits: [
        {
          type: 'fix',
          message: 'Fix Council Members missing on President\'s Special Reappraisal Board member selection list',
          date: '2025-09-05',
          sha: '',
          author: 'symeon',
          issues: [70]
        }
      ]
    }
  },
  {
    id: 'int-v4.2.2+01',
    version: 'int-v4.2.2',
    type: 'Feature/Bugfix',
    title: 'Enhance application search form and fix display issues',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-24',
      date: '2025-07-24',
      commits: [
        {
          type: 'feat/fix',
          message: 'Enhance application search form and fix display issues',
          date: '2025-07-24',
          sha: '',
          author: 'symeon',
          issues: []
        }
      ]
    }
  },
  {
    id: 'int-v4.2.1+01',
    version: 'int-v4.2.1',
    type: 'Bugfix',
    title: 'Fix missing consultants list',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-16',
      date: '2025-07-16',
      commits: [
        {
          type: 'fix',
          message: 'Fix missing consultants list',
          date: '2025-07-16',
          sha: '',
          author: 'symeon',
          issues: []
        }
      ]
    }
  },
  {
    id: 'int-v4.2.0+01',
    version: 'int-v4.2.0',
    type: 'Feature',
    title: 'Add reappraisal applications support',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-04',
      date: '2025-07-04',
      commits: [
        {
          type: 'feat',
          message: 'Add reappraisal applications support',
          date: '2025-07-04',
          sha: '',
          author: 'symeon',
          issues: []
        }
      ]
    }
  },
  {
    id: 'int-v4.2.0-rc.2+01',
    version: 'int-v4.2.0-rc.2',
    type: 'Feature',
    title: 'After first test changes',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-01',
      date: '2025-07-01',
      commits: [
        {
          type: 'chore',
          message: 'After first test changes',
          date: '2025-07-01',
          sha: '',
          author: 'symeon',
          issues: []
        }
      ]
    }
  },
  {
    id: 'int-v4.2.0-rc.1+01',
    version: 'int-v4.2.0-rc.1',
    type: 'Update',
    title: 'Update President decision\'s feature for reappraisals',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-06-17',
      date: '2025-06-17',
      commits: [
        {
          type: 'chore',
          message: 'Update President decision\'s feature for reappraisals',
          date: '2025-06-17',
          sha: '',
          author: 'symeon',
          issues: []
        }
      ]
    }
  },
  {
    id: 'int-v4.2.0-dev.5+01',
    version: 'int-v4.2.0-dev.5',
    type: 'Feature',
    title: 'Before reappraisal president\'s decision implementation',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-06-09',
      date: '2025-06-09',
      commits: [
        {
          type: 'feat',
          message: 'Before reappraisal president\'s decision implementation',
          date: '2025-06-09',
          sha: '',
          author: 'symeon',
          issues: []
        }
      ]
    }
  },
  {
    id: 'int-v4.2.0-dev.4+01',
    version: 'int-v4.2.0-dev.4',
    type: 'Feature/Bugfix',
    title: 'Update Proponent\'s and Academic Director\'s UI and history for reappraisals. Minor fixes',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-05-13',
      date: '2025-05-13',
      commits: [
        {
          type: 'feat/fix',
          message: 'Update Proponent\'s and Academic Director\'s UI and history for reappraisals. Minor fixes',
          date: '2025-05-13',
          sha: '',
          author: 'symeon',
          issues: []
        }
      ]
    }
  },
  {
    id: 'int-v4.2.0-dev.3+01',
    version: 'int-v4.2.0-dev.3',
    type: 'Update',
    title: 'Update Reappraisal Board member\'s UI',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-05-03',
      date: '2025-05-03',
      commits: [
        {
          type: 'chore',
          message: 'Update Reappraisal Board member\'s UI',
          date: '2025-05-03',
          sha: '',
          author: 'symeon',
          issues: []
        }
      ]
    }
  },
  {
    id: 'int-v4.2.0-dev.2+01',
    version: 'int-v4.2.0-dev.2',
    type: 'Update',
    title: 'Improve President\'s UI on reappraisals. First update Board Member\'s UI',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-04-28',
      date: '2025-04-28',
      commits: [
        {
          type: 'chore',
          message: 'Improve President\'s UI on reappraisals. First update Board Member\'s UI',
          date: '2025-04-28',
          sha: '',
          author: 'symeon',
          issues: []
        }
      ]
    }
  },
  {
    id: 'int-v4.2.0-dev.1+01',
    version: 'int-v4.2.0-dev.1',
    type: 'Feature',
    title: 'Reappraisals 2024',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2024',
      date: '2024',
      commits: [
        {
          type: 'feat',
          message: 'Reappraisals 2024',
          date: '2024',
          sha: '',
          author: 'symeon',
          issues: []
        }
      ]
    }
  }
]
// Export the current/active release in the format: 'int-v4.3.0 (build 04)'
export const FRONTEND_RELEASE = `${RELEASES[0].version} (build ${RELEASES[0].build.number})`
// Export RELEASES array for use in config
export { RELEASES }



// WEBPACK FOOTER //
// ./src/releases.js